/* eslint-disable */
// Session 55 · Alpha Launch — Legal Footer.
// Rendered on every page so Privacy / Terms / Contact / Copyright are
// always one click away, per the P0 spec.

import { Link } from "react-router-dom";

export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="legal-global-footer" data-testid="legal-footer">
      <span>© {year} Métier LLC</span>
      <span aria-hidden="true">·</span>
      <Link to="/legal/terms" data-testid="footer-terms">Terms of Service</Link>
      <span aria-hidden="true">·</span>
      <Link to="/legal/privacy" data-testid="footer-privacy">Privacy Policy</Link>
      <span aria-hidden="true">·</span>
      <Link to="/support" data-testid="footer-contact">Contact</Link>
    </footer>
  );
}
